import { render } from "./patient_list.vue?vue&type=template&id=be036c14&scoped=true"
import script from "./patient_list.vue?vue&type=script&lang=js"
export * from "./patient_list.vue?vue&type=script&lang=js"

import "./patient_list.vue?vue&type=style&index=0&id=be036c14&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be036c14"]])

export default __exports__